import { watchSteps } from "@/mocks/home";

export default function WatchOrderSection() {
  return (
    <section id="order" className="section-anchor w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="reveal max-w-2xl">
          <span className="text-xs font-label tracking-[0.2em] text-accent-600">补番指南 / WATCH ORDER</span>
          <h2 className="mt-3 font-heading text-3xl md:text-4xl text-foreground-950">
            第一次看，按这个顺序就对了
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
            对于第一次接触这部作品的观众，按播出顺序观看能获得最完整的体验。
            下面这五条建议，涵盖了从起步到补完原作的关键节点。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          <div className="reveal lg:col-span-2">
            <ol className="relative border-l border-background-300 ml-4 space-y-6">
              {watchSteps.map((s) => (
                <li key={s.step} className="pl-6 md:pl-8 relative">
                  <span className="absolute -left-[13px] top-0 w-6 h-6 rounded-full bg-primary-500 text-background-50 text-[10px] flex items-center justify-center">
                    {s.step}
                  </span>
                  <h3 className="font-heading text-lg md:text-xl text-foreground-950">{s.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{s.text}</p>
                </li>
              ))}
            </ol>
          </div>

          <div className="reveal lg:col-span-1 flex flex-col gap-4">
            <div className="w-full h-[220px] md:h-[300px] rounded-lg overflow-hidden border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=retro%20CRT%20television%20glowing%20in%20a%20dim%20cozy%20room%20with%20warm%20amber%20light%20and%20a%20comfortable%20sofa%2C%20nostalgic%20evening%20atmosphere%2C%20moody%20cinematic%20photography%2C%20soft%20orange%20tones%2C%20shallow%20depth%20of%20field&width=900&height=1100&seq=watch-order-crt-2026&orientation=portrait"
                alt="暖色灯光下正在播放画面的复古电视机"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="rounded-lg bg-primary-50 border border-primary-200 p-5">
              <h3 className="font-label text-sm text-primary-800 flex items-center gap-2">
                <i className="ri-timer-line" />
                观影小贴士
              </h3>
              <ul className="mt-3 space-y-2.5 text-xs md:text-sm text-foreground-700">
                <li className="flex gap-2">
                  <i className="ri-check-double-line text-primary-600 mt-0.5" />
                  日常篇适合放松看，战斗篇建议连贯追。
                </li>
                <li className="flex gap-2">
                  <i className="ri-check-double-line text-primary-600 mt-0.5" />
                  遇到属性战，记住“大空、岚、雨、晴、雷、云、雾”七系。
                </li>
                <li className="flex gap-2">
                  <i className="ri-check-double-line text-primary-600 mt-0.5" />
                  未来篇信息量大，可以边看边梳理势力关系。
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}